module.exports = __webpack_public_path__ + "img/colaborador.5067a88a.svg";